/* CarGrow: bară fixă „Adaugă în coș” pe telefon, vizibilă când butonul principal nu se vede */
(() => {
  if (window.__cargrowStickyAtc) return;
  window.__cargrowStickyAtc = true;

  const mq = window.matchMedia('(max-width: 749px)');

  const init = () => {
    const info = document.querySelector('main[data-template="product"] .product__info-container');
    if (!info) return;
    const getButton = () => info.querySelector('form[action*="/cart/add"] button[type="submit"], form[action*="/cart/add"] button[name="add"]');
    if (!getButton()) return;

    const bar = document.createElement('div');
    bar.className = 'cg-atc';
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', 'Cumpără rapid');
    bar.innerHTML = `
      <div class="cg-atc__info">
        <span class="cg-atc__price"></span>
        <span class="cg-atc__variant"></span>
      </div>
      <button type="button" class="cg-atc__btn"><span class="cg-atc__label">Adaugă în coș</span></button>`;
    document.body.appendChild(bar);
    document.body.classList.add('cg-has-atc');

    const priceEl = bar.querySelector('.cg-atc__price');
    const variantEl = bar.querySelector('.cg-atc__variant');
    const barButton = bar.querySelector('.cg-atc__btn');
    const label = bar.querySelector('.cg-atc__label');

    const text = (node) => (node ? node.textContent.replace(/\s+/g, ' ').trim() : '');

    const refresh = () => {
      const button = getButton();
      if (!button) return;
      const price = info.querySelector('.price');
      let now = '';
      let was = '';
      if (price) {
        const sale = price.querySelector('.price__sale .price-item--sale, .price-item--sale');
        const regular = price.querySelector('.price__sale .price-item--regular');
        if (sale && text(sale)) { now = text(sale); was = text(regular); }
        else now = text(price.querySelector('.price-item--regular, .price-item--last, .price-item')) || text(price);
      }
      priceEl.innerHTML = '';
      const strong = document.createElement('strong');
      strong.textContent = now;
      priceEl.appendChild(strong);
      if (was && was !== now) {
        const old = document.createElement('s');
        old.textContent = was;
        priceEl.appendChild(old);
      }

      const chosen = Array.from(info.querySelectorAll('variant-radios input:checked, variant-selects select, fieldset input[type="radio"]:checked'))
        .map((input) => (input.tagName === 'SELECT' ? input.options[input.selectedIndex].text : input.value))
        .filter((value) => value && value !== 'Default Title');
      variantEl.textContent = chosen.join(' · ');
      variantEl.hidden = !chosen.length;

      const disabled = button.disabled || button.getAttribute('aria-disabled') === 'true';
      const buttonLabel = text(button.querySelector('span')) || text(button) || 'Adaugă în coș';
      label.textContent = buttonLabel.replace(/\bAdăugați\b/i, 'Adaugă');
      barButton.disabled = disabled && !button.classList.contains('loading');
      barButton.classList.toggle('is-loading', button.classList.contains('loading'));
    };

    barButton.addEventListener('click', () => { const button = getButton(); if (button && !barButton.disabled) button.click(); });

    let timer;
    const schedule = () => { clearTimeout(timer); timer = setTimeout(refresh, 60); };
    new MutationObserver(schedule).observe(info, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class', 'disabled', 'aria-disabled', 'checked'] });
    info.addEventListener('change', schedule);
    refresh();

    let ticking = false;
    const update = () => {
      ticking = false;
      const button = getButton();
      if (!button || !mq.matches) { bar.classList.remove('is-visible'); return; }
      const rect = button.getBoundingClientRect();
      const barTop = window.innerHeight - bar.offsetHeight;
      const visible = rect.top >= 0 && rect.bottom <= barTop + 4;
      bar.classList.toggle('is-visible', !visible);
    };
    const onScroll = () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    mq.addEventListener('change', update);
    update();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
